import localforage from 'localforage';
import { createJSONStorage } from 'zustand/middleware';
const instances = new Map();
export const createLocalForageStorage = name => {
  const instance = localforage.createInstance({
    name,
    driver: [localforage.INDEXEDDB]
  });
  instances.set(name, instance);
  return createJSONStorage(() => ({
    getItem: async key => {
      const value = await instance.getItem(key);
      return value ?? null;
    },
    setItem: async (key, value) => {
      await instance.setItem(key, value);
    },
    removeItem: async key => {
      await instance.removeItem(key);
    }
  }));
};

/**
 * Clears every localforage instance backing a persisted store. Called on logout
 * so the underlying IndexedDB databases are torn down deterministically rather
 * than relying on the persist middleware's async, unawaited reset write.
 */
export const clearPersistedStores = () => Promise.all([...instances.values()].map(instance => instance.clear()));